// extracted by mini-css-extract-plugin
export default {"container":"S02_Marquee_container__UVTzO","wrapper":"S02_Marquee_wrapper__c82yZ","marquee":"S02_Marquee_marquee__UtbZI","track":"S02_Marquee_track__Lsjtu"};